import { HttpClient } from '../services';
import { SearchData, AnalyticFlowResponse, AnalyticJobBriefInfo, KillScheduleJobInfo } from './types';
import { makeParamURL } from './utiles';
// import { API } from '../../constants/settings';
import { ApiResponse } from '../data-source-handler';

class AnalyticHandlerClass {
    PagenationSearchSort(link: string, data: SearchData, callback: (arg0: AnalyticFlowResponse)  => void, errorHandlerCallback? : (arg0: any) => void) {
        const paramURL: string = makeParamURL(data);
        HttpClient.Get('Pagenation Search Sort', `${link}/v1/analytic_flow/pagination_search_sort/` + paramURL+'&sortby=time&orderby=desc', callback, errorHandlerCallback);
    }

    Get(link: string, id: number, callback: (arg0: any) => void, errorHandlerCallback?: (arg0: any) => void ) {
        HttpClient.Get('Get By ID', `${link}/v1/analytic_flow/` + id, callback, errorHandlerCallback);
    }

    Delete(link: string, id: number, callback: (arg0: any) => void, errorHandlerCallback?: (arg0: any) => void) {
        HttpClient.Delete('Delete', `${link}/v1/analytic_flow/` + id, callback, errorHandlerCallback);
    }

    GetAllJobs(link: string, callback: ApiResponse<{data: AnalyticJobBriefInfo[]}>) {
        HttpClient.Get('Get By ID', `${link}/v2/analytic_flow/`, callback);
    }

    CreateKillJob(link: string, data: KillScheduleJobInfo, callback: ApiResponse<any>) {
        HttpClient.Post('Create a kill job', `${link}/v2/scheduled-kill-job/`, data, callback);
    }


    GetKillScheduledJobs(link: string, data: SearchData, callback: any) {
        // data = { page: 1, size: 10 };
        const paramURL: string = makeParamURL(data);
        HttpClient.Get('Get Kill Scheduled jobs', `${link}/v2/scheduled-kill-job/` + paramURL+'&sortby=time&orderby=desc', callback);
    }

}

const AnalyticHandler = new AnalyticHandlerClass();

export { AnalyticHandler };